import { TagDefinition } from 'src/models';

const regexPatterns = [
  {
    id: 'sep-operations',
    label: 'SEP Operations',
    charts: [
      {
        id: 'categorical-data-status-indicator',
        label: 'Categorical Data (Status Indicator)',
        regex: [
          /\.SS30001_dev[a-zA-Z0-9]+\.F_DesiredOperatingMode$/i,
          /\.SS30001_dev[a-zA-Z0-9]+\.F_OperatingMode$/i,
          /\.SS30001_dev[a-zA-Z0-9]+\.F_ConnSt$/i,
          /\.SS7999_dev[a-zA-Z0-9]+\.F_GridStatus$/i,
        ],
      },
      {
        id: 'graph-1-current-flow',
        label: 'Graph 1 (Current Flow)',
        regex: [
          /\.SS30001_dev[a-zA-Z0-9]+\.F_A_L1$/i,
          /\.SS30001_dev[a-zA-Z0-9]+\.F_A_L2$/i,
          /\.SS30001_dev[a-zA-Z0-9]+_scaled\.F_MSPA_L1$/i,
          /\.SS30001_dev[a-zA-Z0-9]+_scaled\.F_MSPA_L2$/i,
        ],
      },
      {
        id: 'graph-2-voltage-frequency',
        label: 'Graph 2 (Voltage & Frequency)',
        regex: [
          /\.SS30001_dev[a-zA-Z0-9]+\.F_Hz$/i,
          /\.SS30001_dev[a-zA-Z0-9]+_scaled\.F_PhVphL1$/i,
          /\.SS30001_dev[a-zA-Z0-9]+_scaled\.F_PhVphL2$/i,
        ],
      },
    ],
  },
  {
    id: 'power-flow-summary',
    label: 'Power Flow Summary',
    charts: [
      {
        id: 'graph-1-grid-generator-power',
        label: 'Graph 1 (Grid & Generator Power)',
        regex: [
          /\.SS39997\.F_TotalPowerFromGrid$/i,
          /\.SS39997\.F_TotalPowerToGrid$/i,
          /\.SS39997\.F_TotalPowerFromGenerator$/i,
        ],
      },
      {
        id: 'graph-2-battery-power',
        label: 'Graph 2 (Battery Power)',
        regex: [/\.SS39997\.F_TotalPowerFromBattery$/i, /\.SS39997\.F_TotalPowerToBattery$/i],
      },
      {
        id: 'graph-3-solar-power',
        label: 'Graph 3 (Solar Power)',
        regex: [/\.SS39997\.F_TotalPowerFromACCoupledPV$/i, /\.SS39997\.F_TotalPowerFromDCPV$/i],
      },
      {
        id: 'graph-4-ev-charger-load',
        label: 'Graph 4 (EV Charger & Load)',
        regex: [
          // done
          /\.SS39997\.F_TotalPowerFromEVCharger$/i,
          /\.SS39997\.F_TotalPowerToEVCharger$/i,
          /\.SS39997\.F_TotalPowerToLoad$/i,
        ],
      },
    ],
  },
  {
    id: 'inverter',
    label: 'Inverter',
    charts: [
      {
        id: 'graph-1-voltage',
        label: 'Graph 1 (Voltage)',
        regex: [
          /\.SS7011_dev[a-zA-Z0-9]+\.F_VL1$/i,
          /\.SS7011_dev[a-zA-Z0-9]+\.F_VL2$/i,
          /\.SS7011_dev[a-zA-Z0-9]+\.F_VL3$/i,
          /\.SS1601_dev[a-zA-Z0-9]+\.R[0-9]+_DCV$/i,
          /\.SS802\.F_V$/i,
        ],
      },
      {
        id: 'graph-2-current',
        label: 'Graph 2 (Current)',
        regex: [
          /\.SS30001_dev[a-zA-Z0-9]+\.R0_AL1$/i,
          /\.SS30001_dev[a-zA-Z0-9]+\.R0_AL2$/i,
          /\.SS7011_dev[a-zA-Z0-9]+\.F_A$/i,
          /\.SS1601_dev[a-zA-Z0-9]+\.R[0-9]+_DCA$/i,
          /\.SS802\.F_A$/i,
        ],
      },
    ],
  },
  {
    id: 'grid',
    label: 'Grid',
    charts: [
      {
        id: 'graph-1-grid-voltage',
        label: 'Graph 1 (Grid Voltage)',
        regex: [
          /\.SS7011_dev[a-zA-Z0-9]+\.F_VL1L2$/i,
          /\.SS7011_dev[a-zA-Z0-9]+\.F_VL2L3$/i,
          /\.SS7011_dev[a-zA-Z0-9]+\.F_VL3L1$/i,
        ],
      },
      {
        id: 'graph-2-grid-frequency-power-flow',
        label: 'Graph 2 (Grid Frequency & Power Flow)',
        regex: [
          /\.SS7011_dev[a-zA-Z0-9]+\.F_Hz$/i,
          /\.SS39997\.F_TotalPowerFromGrid$/i,
          /\.SS39997\.F_TotalPowerToGrid$/i,
        ],
      },
      {
        id: 'graph-3-sep-voltage-if-applicable',
        label: 'Graph 3 (SEP Voltage, if applicable)',
        regex: [
          /\.SS30001_dev[a-zA-Z0-9]+\.F_PhV$/i,
          /\.SS30001_dev[a-zA-Z0-9]+_scaled\.F_PhVphL1$/i,
          /\.SS30001_dev[a-zA-Z0-9]+_scaled\.F_PhVphL2$/i,
        ],
      },
    ],
  },
  {
    id: 'battery',
    label: 'Battery',
    charts: [
      {
        id: 'graph-1-battery-energy-flow',
        label: 'Graph 1 (Battery Energy Flow)',
        regex: [
          /\.SS802\.F_V$/i,
          /\.SS802\.F_A$/i,
          /\.SS802_scaled\.F_W$/i,
          /\.SS802_scaled\.F_SoC$/i,
        ],
      },
      {
        id: 'graph-2-temperature-monitoring',
        label: 'Graph 2 (Temperature Monitoring)',
        regex: [
          /\.SS805_dev[a-zA-Z0-9]+\.F_CellTmpMax$/i,
          /\.SS805_dev[a-zA-Z0-9]+\.F_CellTmpMin$/i,
        ],
      },
      {
        id: 'graph-3-temperature-monitoring',
        label: 'Graph 3 (Temperature Monitoring)',
        regex: [
          /\.SS805_dev[a-zA-Z0-9]+\.F_CellTmpMaxCell$/i,
          /\.SS805_dev[a-zA-Z0-9]+\.F_CellTmpMinCell$/i,
        ],
      },
      {
        id: 'graph-4-cell-voltage-monitoring',
        label: 'Graph 4 (Cell Voltage Monitoring)',
        regex: [/\.SS805_dev[a-zA-Z0-9]+\.F_CellVMax$/i, /\.SS805_dev[a-zA-Z0-9]+\.F_CellVMin$/i],
      },
      {
        id: 'graph-5-cell-voltage-monitoring',
        label: 'Graph 5 (Cell Voltage Monitoring)',
        regex: [
          /\.SS805_dev[a-zA-Z0-9]+\.F_CellVMaxCell$/i,
          /\.SS805_dev[a-zA-Z0-9]+\.F_CellVMinCell$/i,
        ],
      },
    ],
  },
];

const getViewsData = (tags: TagDefinition[]) => {
  const views = regexPatterns.map((pattern) => {
    return {
      id: pattern.id,
      label: pattern.label,
      charts: pattern.charts.map((chart) => ({
        id: chart.id,
        label: chart.label,
        tags: tags.filter((tag) => chart.regex.some((regex) => regex.test(tag.id))),
      })),
    };
  });

  // Filter views and charts
  const filteredViews = views
    .map((view) => {
      if (view.id === 'sep-operations') {
        // For sep-operations: if any chart has no tags, return null to remove the entire view
        return view.charts.every((chart) => chart.tags.length > 0) ? view : null;
      } else {
        // For other views: remove charts that have no tags
        const filteredCharts = view.charts.filter((chart) => chart.tags.length > 0);
        return filteredCharts.length > 0 ? { ...view, charts: filteredCharts } : null;
      }
    })
    .filter((view): view is NonNullable<typeof view> => view !== null);

  return filteredViews;
};

export default getViewsData;
